import React from "react";
import classNames from "classnames";
import styles from "../wf.dashboard.module.css";
import {Detail} from "@commons/mapping/dashboard.types";
import moment from "moment";
import {IconAlertTriangle, IconBan, IconCheck, IconCircleFilled, IconHourglass, IconScale} from "@tabler/icons-react";

export const Triangle: React.FC<{ bgColor?: string }> = ({bgColor = 'currentColor'}) =>
    <svg xmlns="http://www.w3.org/2000/svg" fill={bgColor} viewBox="0 0 21 22" strokeWidth={1.5} stroke={bgColor}>
        <polygon points="21,22 21,0 0,22"></polygon>
    </svg>;

export const InAttesaIcon: React.FC<{ withNumber?: boolean }> = ({withNumber = false}) => <span
    className={classNames(withNumber ? styles.IconHourglassConNumero : styles.IconHourglass, styles.inAttesaColor)}>
<IconHourglass size={16}/>
</span>;
export const InValutazioneIcon: React.FC<{ withNumber?: boolean }> = ({withNumber = false}) => <span
    className={classNames(withNumber ? styles.IconHourglassConNumero : styles.IconHourglass, styles.inValutazioneColor)}>
<IconScale size={16}/>
</span>;
export const DaEvadereIcon: React.FC<{ withNumber?: boolean }> = ({withNumber = false}) => <span
    className={classNames(withNumber ? styles.IconHourglassConNumero : styles.IconHourglass, styles.inAttesaColor)}>
<IconAlertTriangle className="h-4 w-4" aria-hidden="true"/>
</span>;

const PallinoMancante = () => <span className={classNames(styles.giustificativoMancanteColor, 'h-5 w-5')}><IconCircleFilled size={16}/></span>
const PallinoEccedente = () => <span className={classNames(styles.giustificativoEccedenteColor, 'h-5 w-5')}><IconCircleFilled size={16}/></span>

const StateDetail: React.FC<{ detail?: Detail }> = ({detail}) => {
    if (!detail)
        return <span className="h-5 w-5"></span>;

    if (detail.wf && detail.wf.stato === 'IN_ATTESA') {
        return <span className={classNames(styles.inAttesaColor, 'h-5 w-5')}>
            <IconHourglass size={16}/>
        </span>
    }

    if (detail.wf && detail.wf.stato === 'IN_VALUTAZIONE') {
        return <span className={classNames(styles.inValutazioneColor, 'h-5 w-5')}>
            <IconScale size={16}/>
        </span>
    }

    if (detail.wf && detail.wf.stato === 'ACCETTATA') {
        return <span className={classNames(styles.accettataColor)}>
            <IconCheck className="h-5 w-5" aria-hidden="true"/>
        </span>
    }

    if (detail.wf && detail.wf.stato === 'RIFIUTATA') {
        return <span className={classNames(styles.respintaColor)}>
            <IconBan size={16}/>
        </span>
    }

    return <></>;
}
const HH: React.FC<{ detail?: Detail }> = ({detail}) => {
    const formatQuantita = (detail: Detail) => {
        const previsto = detail.hhPreviste / 60.0;
        if (detail.wf)
            return (detail.wf.annullata || detail.quantita === previsto) ? '' : detail.quantita;
        else
            return detail.quantitaGiustificativo === previsto ? '' : detail.quantitaGiustificativo;
    }

    if (detail) {
        const q = formatQuantita(detail);
        if (q)
            return <>{q}<span className="ml-[1px] text-xs">hh</span></>
        else
            return <></>
    } else
        return <><span className="ml-[1px] text-xs">hh</span></>
}
export const CellDetail: React.FC<{ details: Detail[] }> = ({details}) => {
    const formatDate = (date: string) => moment(date).startOf('day').format('dddd LL');

    if (details && details.length > 0) {
        const detailsWF = details.filter((detail: Detail) => Detail.isAWF(detail));
        // N.B. Prelevo il primo elemento utile con mancante ed eccedente da presenze: tali records sono presenti tante volte quante sono le richieste di WF
        // Comportamento da store procedure BROWSE_WORKFLOW_DASHBOARD2
        const detailsMancante = details.find((detail: Detail) => Detail.isGiuMancante(detail));
        const detailsEccedente = details.find((detail: Detail) => Detail.isGiuEccedente(detail));
        const hasGiuMancante = !!detailsMancante;
        const hasGiuEccedente = !!detailsEccedente;
        return <>
            <p className={classNames('mb-1', details[0].festivo ? 'text-red-500' : 'text-white')}>{formatDate(details[0].giornoDt!)}&nbsp;{details[0].festivo && 'FESTIVO'}</p>
            {details[0].hhWeekMedie === 40 && <p>Tempo pieno</p>}
            {details[0].hhWeekMedie < 40 && <p>Part time: {details[0].hhWeekMedie}hh</p>}
            {(detailsWF.length > 0 || hasGiuMancante || hasGiuEccedente) && <p className="mt-1">Elenco causali/giustificativi</p>}
            <ul className="text-gray-200">
                {detailsWF.map((detail: Detail, index: number) => {
                    return <li key={index}>
                        <div className="inline-flex"><StateDetail detail={detail}/><span
                            className={classNames(Detail.isAnnullata(detail) && 'line-through')}>{detail.descrizioneCausale} <HH detail={detail}/></span>
                        </div>
                    </li>
                })}

                {hasGiuMancante && <li>
                    <div className="inline-flex"><PallinoMancante/>
                        <span className={styles.assenteColor}>Altre assenze {detailsMancante.quantitaGiustificativo}<HH/></span></div>
                </li>}

                {hasGiuEccedente && <li>
                    <div className="inline-flex"><PallinoEccedente/>
                        <span className={styles.eccedenteColor}>Altre eccedenze {detailsEccedente.quantitaGiustificativo}<HH/></span></div>
                </li>}
            </ul>
        </>
    } else
        return <></>;
}